import {
  Center,
  Paper,
  Stack,
  Title,
  Text,
  useMantineTheme,
} from '@mantine/core';
import { IconCircleDashedCheck } from '@tabler/icons-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// -----------------------------------------------------------------------------
export const SuccessPage: FC = () => {
  const { t } = useTranslation(['status-pages']);
  const theme = useMantineTheme();

  // ---------------------------------------------------------------------------
  return (
    <Center h="100%">
      <Paper p="xl" radius="lg" shadow="xl">
        <Stack justify="center" align="center" gap="lg">
          <IconCircleDashedCheck size={64} color={theme.colors.green[4]} />

          <Stack justify="center" align="center" gap="4px">
            <Title m="0">{t('success.title', { ns: 'status-pages' })}</Title>
            <Text>{t('success.description', { ns: 'status-pages' })}</Text>
          </Stack>

          <Text c="dimmed">{t('success.action', { ns: 'status-pages' })}</Text>
        </Stack>
      </Paper>
    </Center>
  );
};
